import React from "react";
import BaseReportPage from "./_BaseReportPage";
import { render } from "@testing-library/react";

const extractLateRemark = (remark = "") => {
  console.log("Extracting late remark from:", remark);
  if (!remark) return "-";
  const parts = remark.split("|").map(x => x.trim());
  const late = parts.find(p => p.toLowerCase().startsWith("late"));
  return late || "-";
};

const columns = [
  { title: "Date", key: "date" },
  { title: "Code", key: "employee_code" },
  { title: "Name", key: "name" },
  {
    title: "Shift In",
    key: "shift_in",
  },
  { title: "In Time", key: "in_time" },
  {
    title: "Remarks",
    key: "remarks",
    render: (row) => extractLateRemark(row),
  },
];

export default function LateReportPage() {
  return (
    <BaseReportPage
      apiEndpoint="/hrms/attendance?only=late"
      columns={columns}
      title="Late Comers Report"
      emptyMessage="No late records"
      defaultFilters={{ only: "late" }}
      downloadEndpoint="/hrms/attendance/download"
    />
  );
}
